import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_ALL_ORGANIZATIONS: createSagaAction('GET_ALL_ORGANIZATIONS'),
  CREATE_NEW_ORGANIZATION: createSagaAction('CREATE_NEW_ORGANIZATION'),
  QUICK_ADD_NEW_ORGANIZATION: createSagaAction('QUICK_ADD_NEW_ORGANIZATION')
}

// Action Creators
export const actions = {
  getAllOrganizations: () => ({ type: constants.GET_ALL_ORGANIZATIONS.ACTION }),
  createNewOrganization: ({ organization, userId, next }) => ({
    type: constants.CREATE_NEW_ORGANIZATION.ACTION,
    organization,
    userId,
    next
  }),
  quickAddNewOrganization: ({ organization, userId }) => ({
    type: constants.QUICK_ADD_NEW_ORGANIZATION.ACTION,
    organization,
    userId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.GET_ALL_ORGANIZATIONS.SUCCESS:
      return { ...state, payload }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/organizationsActions.js